/**
 * Base URL for sharing links: event's custom domain (if set) or app origin.
 * @param {{ custom_domain?: string | null } | null | undefined} event - Event object; may have custom_domain.
 * @returns {string} Base URL without trailing slash (e.g. https://eventos.example.com or https://app.example.com)
 */
export function getBaseUrlForEvent(event) {
  const domain = event?.custom_domain && String(event.custom_domain).trim();
  if (domain) {
    const normalized = domain.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
    return normalized ? `https://${normalized}` : getAppBaseUrl();
  }
  return getAppBaseUrl();
}

/**
 * App base URL (no custom domain). Use when no event context or event has no custom_domain.
 * @returns {string}
 */
export function getAppBaseUrl() {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
}

/**
 * Build the shareable short link URL (e.g. /event-slug/agent-slug) with correct base.
 * @param {{ id: string, event_slug?: string, custom_domain?: string | null }} event
 * @param {{ slug?: string }} link - Sharing link with slug
 * @returns {string}
 */
export function getShareableShortUrl(event, link) {
  const base = getBaseUrlForEvent(event);
  const eventSlug = (event?.event_slug || '').trim() || 'event';
  const agentSlug = (link?.slug || '').trim() || '';
  const path = agentSlug ? `/${eventSlug}/${agentSlug}` : `/${eventSlug}`;
  return base ? `${base}${path}` : path;
}

/**
 * Build the register page URL for an event with correct base.
 * @param {{ id: string, custom_domain?: string | null }} event
 * @returns {string}
 */
export function getRegisterUrlForEvent(event) {
  const base = getBaseUrlForEvent(event);
  const eventId = event?.id;
  if (!eventId) return base || '';
  return base ? `${base}/register/${eventId}` : `/register/${eventId}`;
}
